import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CurrentSearchParams } from '../../../../decorators/current-search-params.decorator';
import { RestaurantExplore } from '../../../../domains/restaurant-explore';
import { PickerCustomOption } from '../../../../models/enums/picker-custom-option';
import { SearchParams } from '../../../../models/search-params';
import { SearchResult } from '../../../../models/search-result';
import { SearchCityService } from '../../../../services/search-city.service';

@Component({
  selector: 'app-navbar-bottom-restaurants-picker',
  templateUrl: './navbar-bottom-restaurants-picker.component.html',
  styles: [
  ]
})
export class NavbarBottomRestaurantsPickerComponent implements OnInit {
  @Input() searchResult: SearchResult;
  @Input() explore = false;
  @Input() isBasketEmpty = true;

  @Output() restaurantSelected = new EventEmitter<RestaurantExplore>();

  @CurrentSearchParams() searchParams: SearchParams;

  constructor(private searchCityService: SearchCityService) {
  }

  ngOnInit(): void {
  }

  onRestaurantsPickerSelected(value) {
    if (value === PickerCustomOption.EXPLORE_SEARCH) {
      this.searchCityService.openSearchCityModalSubject.next(true);
    } else {
      this.searchResult.groups?.forEach(groups => {
        groups.sections.forEach(typeCategorySectionI => {
          if (typeCategorySectionI.keysString === value) {
            this.restaurantSelected.emit(typeCategorySectionI.getFirstRestaurant());
          }
        });
      });
    }
  }
}
